import { httpsCallable } from 'firebase/functions';

import { getFunctions } from './helpers';

export const getFeaturebaseToken = async () => {
  const functions = getFunctions();
  const getToken = httpsCallable<void, { token: string }>(
    functions,
    'featurebaseSso-generateFeaturebaseSsoToken',
  );

  const { data } = await getToken();
  return data;
};
